import { ObservableMap } from 'owa-mobx4-adapter';
import { createStore } from 'satcheljs';
export { ObservableMap };
var listViewDefaultStore = {
    conversationItems: new ObservableMap({}),
    itemContextMenuState: null,
    selectedTableViewId: null,
    tableViewConversationRelations: new ObservableMap({}),
    tableViewItemRelations: new ObservableMap({}),
    tableViews: new ObservableMap({}),
    attachmentViewStates: new ObservableMap({}),
    expandedConversationViewState: {
        expandedRowKey: null,
        selectedNodeIds: [],
        shouldBeExpanded: false,
        busStopStateMap: new ObservableMap({}),
    },
    rowAttachmentPreviewWellViews: new ObservableMap({}),
    focusedOtherDropViewState: null,
    couponPeekPreviews: new ObservableMap({}),
};
export var getStore = createStore('listview', listViewDefaultStore);
var listViewStore = getStore();
export default listViewStore;
//# sourceMappingURL=Store.js.map